import { ActivePosition } from "src/types/products";
import { getCurrency } from "src/utils/currencies";

import ISIN from "../Cells/ISIN";
import LocalPrice from "../Cells/LocalPrice";
import LocalValue from "../Cells/LocalValue";
import Market from "../Cells/Market";
import PositionName from "../Cells/PositionName";
import PositionSectionName from "../Cells/PositionSectionName";
import PositionValue from "../Cells/PositionValue";
import Shares from "../Cells/Shares";
import Weight from "../Cells/Weight";

type Col = {
	id: string;
	label: string;
	Cell: (props: ActivePosition) => JSX.Element | null;
	align?: "center" | "left";
};

const cols = (currency: string, isSection?: boolean): Col[] => [
	{
		id: "type",
		Cell: isSection ? PositionSectionName : PositionName,
		align: "left",
		label: "result_demo.name"
	},
	{
		id: "isin",
		Cell: ISIN,
		align: "center",
		label: "ISIN"
	},
	{
		id: "market",
		Cell: Market,
		align: "center",
		label: "result_demo.market"
	},
	{
		id: "localValue",
		Cell: LocalValue,
		align: "center",
		label: "result_demo.localAmount"
	},
	{
		id: "localPrice",
		Cell: LocalPrice,
		align: "center",
		label: "result_demo.localPrice"
	},
	{
		id: "shares",
		Cell: Shares,
		align: "center",
		label: "result_demo.titles"
	},
	{
		id: `Valor ${getCurrency(currency)}`,
		Cell: PositionValue,
		align: "center",
		label: "result_demo.amount"
	},
	{
		id: "weight",
		Cell: Weight,
		align: "center",
		label: "result_demo.weight"
	}
];

export default cols;
